/* eslint-disable no-throw-literal */
import {
  GET_QUESTION_ALL,
  GET_QUESTION_LIST,
  QUESTION_DELETE,
  QUESTION_CREATE,
  GET_QUESTION_DETAIL,
  QUESTION_UPDATE
} from './mutation-types'

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_QUESTION_ALL] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/questions/all_get', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    [GET_QUESTION_LIST] ({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiGet', { url: '/master/questions', data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    [QUESTION_DELETE] ({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiDelete', {url: `/master/questions/${params.data.id}`})
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    [QUESTION_CREATE] ({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiPost', { url: '/master/questions', data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    [GET_QUESTION_DETAIL] ({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiGet', { url: `/master/questions/${params.id}/edit` })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    [QUESTION_UPDATE] ({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiPatch', { url: `/master/questions/${params.id}`, data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    }
  },
  mutations: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/question.js